export interface WorkspaceApplicantDTO {
  user_public_id: string
  status: WorkspaceApplicantStatusDTO
  date_created: string
  date_modified: string
  date_invited: string | null
}

export enum WorkspaceApplicantStatusDTO {
  Applied = 'APPLIED',
  Rejected = 'REJECTED',
  Invited = 'INVITED',
  Accepted = 'ACCEPTED',
  Withdrawn = 'WITHDRAWN',
  Expired = 'EXPIRED',
}
